
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import Typography from '@/ui-kit/components/typography';
import Gutter from '@/ui-kit/components/gutter';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { ModalSlotName } from '@/ui-kit/components/modal/enums';
import {
  StyleSizeType,
  StylePositionType,
  StyleColorSchemeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import PMBookingCancellationForm from './form/PMBookingCancellationForm';

export default {
  name: 'PMBookingCancellationModal',
  components: {
    ModalWindow,
    Typography,
    Gutter,
    PMBookingCancellationForm,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      ModalSlotName,
      TypographyType,
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      StyleFontWeightType,
    };
  },
  methods: {
    handleCancelClick() {
      this.closeHandler();
    },
    handleSubmitClick(cancellationReason) {
      this.closeHandler(cancellationReason);
    },
  },
};
